export default "__VITE_ASSET__61sZ3NGi__"